export default "__VITE_ASSET__DNz1R5IN__"